export default __webpack_public_path__ + "cffadaf580573ab808228b6689b5a121.svg";